import { gql } from "gql";

export const GET_CURRENT_USER_PROTECTION_TOKEN = gql(/* GraphQL */ `
  query GetCurrentUserProtectionToken {
    getCurrentUserProtectionTokens {
      ...CurrentUserProtectionToken
    }
  }
`);
